<template>
  <!-- 悬浮广告位 -->
  <x-float-view :class="_.floatAd" @click="$emit('click')">
    <van-image
      v-track="{
        disabled: !track,
        ...track,
      }"
      :class="_.image"
      :src="image"
      fit="contain"
    />
  </x-float-view>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    props: {
      image: {
        type: String,
        required: true,
      },
      track: {
        type: Object,
        default: undefined,
      },
    },
  })
</script>

<style lang="scss" module>
  .floatAd {
    position: fixed;
    // fix: iPhone 8 下不随滑动实时更新问题
    transform: translate3d(0, 0, 0);
    bottom: 90px;
    right: 0;
    width: 60px;

    .image {
      width: 100%;
    }
  }
</style>
